import delegate from "delegate-it";
import ajax from "@/scripts/common/ajax";
import { scrollToIfNeeded } from "@/scripts/common/scroll-to";
import { updateQueryParams } from "@/scripts/common/util";

const form = document.querySelector(".filter-form");
const pageContent = document.querySelector("[data-page-content]");

let activeController = null;

const updateResults = async () => {
  activeController?.abort();

  const controller = new AbortController();
  activeController = controller;

  const loadingTimer = setTimeout(() => {
    pageContent.classList.add("is-loading");
  }, 300);

  try {
    const res = await ajax.get(window.location.href, { signal: controller.signal }).json();

    pageContent.innerHTML = res.page;

    if (res.isFiltered) {
      scrollToIfNeeded(pageContent, 24);
    }
  } catch (err) {
    if (err.name === "AbortError") return;
    throw err;
  } finally {
    clearTimeout(loadingTimer);

    if (activeController === controller) {
      pageContent.classList.remove("is-loading");
      activeController = null;
    }
  }
};

const handleFilter = (e) => {
  const url = updateQueryParams([[e.target.name, e.target.value]]);

  window.history.replaceState({}, "", url);

  updateResults();
};

const handleFilterClear = (e) => {
  e.preventDefault();

  const url = updateQueryParams(false);
  window.history.replaceState({}, "", url);

  updateResults();
};

document.addEventListener("DOMContentLoaded", () => {
  if (form) {
    delegate(".filter-form", "change", handleFilter);
    delegate(".filter-form", "form:clear", handleFilterClear);
  }
});
